import { useTranslation } from 'react-i18next'
import { Badge } from '@/components/ui/Badge'
import { STATUSES, formatRate, statusMeta } from '../status'
import type { StatusCounts } from '../types'

interface SummaryChipsProps {
  counts: StatusCounts
  /** Students on the roster; shows an "Unmarked" chip when given. */
  total?: number
  className?: string
}

export function SummaryChips({ counts, total, className }: SummaryChipsProps) {
  const { t } = useTranslation('attendance')
  const unmarked = total !== undefined ? Math.max(0, total - counts.marked) : 0
  return (
    <ul className={className ?? 'flex flex-wrap gap-2'} aria-label={t('Attendance summary')}>
      {STATUSES.map((s) => (
        <li key={s}>
          <Badge tone={statusMeta[s].tone} dot>
            {t(statusMeta[s].label)} <span className="tabular">{counts[statusMeta[s].countKey]}</span>
          </Badge>
        </li>
      ))}
      {total !== undefined ? (
        <li>
          <Badge tone="neutral">
            {t('Unmarked')} <span className="tabular">{unmarked}</span>
          </Badge>
        </li>
      ) : null}
      <li>
        <Badge tone="neutral" className="font-semibold">
          {t('Rate')} <span className="tabular">{formatRate(counts.rate)}</span>
        </Badge>
      </li>
    </ul>
  )
}
